import { ChangeDetectionStrategy, Component, computed, HostListener, input, output, inject } from '@angular/core';
import { Home } from '@library/store/homes/homes.interface';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { DirectivesModule } from '@library/ui/directives/directives.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { Station } from '@store/weathermap.store';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-station',
  imports: [
    TextModule,
    IconModule,
    PipesModule,
    DirectivesModule,
  ],
  templateUrl: './station.component.html',
  styleUrl: './station.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StationComponent {
  private readonly modulesFacade = inject(ModulesFacade);

  outdoorModule = input<Module>();
  station = input<Module>();
  home = input<Home>();

  selectStation = output<{station: Station, coordinates: number[]}>();

  name = computed(() => {
    if (this.home().mode === 'favorite') {
      return this.home().name;
    }
    else {
      return this.outdoorModule().name;
    }
  });

  EnumMeasureTypes = EnumMeasureTypes;

  coordinates = computed(() => (this.home().mode ? this.station().coordinates : this.home().place.coordinates));
  altitude = computed(() => (this.home().mode ? this.station().altitude : this.home().place.altitude));

  @HostListener('click')
  async click(): Promise<void> {
    const modules = await firstValueFrom(this.modulesFacade.getModulesById(this.station().modules_bridged));

    this.selectStation.emit({
      station: {
        id: this.station().id,
        city: this.name(),
        altitude: this.altitude(),
        modules,
      },
      coordinates: this.coordinates(),
    });
  }
}
